import { memo, useCallback, useState } from 'react';
import AnimateTop from 'components/AnimateTop';
import StepLayout from 'components/layout/StepLayout';
import { useDispatch, useSelector } from 'react-redux';
import { nextStep, prevStep, fillDjangoGoogleApiData } from 'store/slices/global.slice';
import { Step4Content } from './Step4.styled';
import Footer from 'components/footer/Footer';
import { FooterOkBtn, FooterPressText } from 'components/footer/Footer.styled';
import { HiOutlineCheck } from 'react-icons/hi';
import BaseSpinner from 'components/common/BaseSpinner';
import { AnimatePresence, motion } from 'framer-motion';
import { fadeTop } from 'styles/animations';
import { Form, Formik } from 'formik';
import BaseGoogleAutocomplete from 'components/common/BaseGoogleAutocomplete';
import { VALIDATION_STEP_4 } from 'utils/validations';
import { fillStep4Data } from 'store/slices/form.slice';
import { api } from 'utils/axios';

const searchOptions = {
  componentRestrictions: { country: 'us' },
};

const Step4 = () => {
  const dispatch = useDispatch();
  const { global } = useSelector((state) => state);
  const [loader, setLoader] = useState(false);
  const [loaderGoogle, setLoaderGoogle] = useState(false);
  const [addressObj, setAddressObj] = useState(null);
  const [errGoogle, setErrGoogle] = useState();

  const onSubmit = useCallback(
    async (values) => {
      if (values.address && addressObj) {
        await dispatch(
          fillStep4Data({
            address: values.address,
            addressObj: addressObj,
          })
        );
        const adst = values.address.split(',');
        let locationArea = adst[1].trim() + ', ' + adst[2].replace(/ /g, '') + ',' + adst[3];
        setLoader(true);
        try {
          let { data } = await api.post(
            `${process.env.REACT_APP_NEW_API}`,
            {
              locationStreet: adst[0].trim(),
              locationState: adst[2].replace(/ /g, ''),
              locationCity: adst[1].trim(),
              locationArea
            }
          );
          let parsedData;
          let miles;
          let cost=0;
          if (typeof data === 'object') {
            parsedData = data.distance.split(' ')[0].replace(',', '');
            if (parsedData==='') parsedData=999999;
            miles = Number(parsedData);
            cost = Number(data.cost);
          } else {
            parsedData = data.split('{');
            miles = Number(parsedData[0].split(' ')[0]);
          }
          if (isNaN(miles)) miles = 999999;
          let newData = {};
          newData.address = values.address;
          newData.fee = 1.24;
          newData.cost = cost;
           console.log(cost);
          newData.show_button = 3;
          console.log(miles);
          if (miles <= 25) {
            newData.msg = "Good news. This address is within our area of service.";
          }
          if (miles > 25 && miles <= 100) {
            newData.msg = `Good news, you’re within our area of service. A millage fee of a minimum of $${newData.cost} will be added to the order.`;
            
          }
          if (miles > 100) {
            newData.msg = `Oh, we're very sorry but at the moment we are not servicing the address you provided. We're continously expanding our services and would love to inform you when our technicians are able to visit this area.`;
            newData.show_button = 2;
          }
          newData.distanceMiles = miles;
          const tot = ((miles*1.24)+90);
          localStorage.setItem("totalToPay", tot.toFixed(2));
          data = newData;
          console.log(data);
          setLoader(false);
          await dispatch(fillDjangoGoogleApiData({ data }));
          await dispatch(nextStep({ feedback: true }));
        } catch (err) {
          setLoader(false);
          console.error(err);
        }
      } else {
        setErrGoogle('Please choose address.');
      }
    },
    [addressObj, dispatch]
  );

  return (
    <AnimateTop>
      {!loader ? (
        <>
          {!global.feedbackMsg ? (
            <StepLayout title='Please enter the address where the service will be rendered.*'>
              <Formik
                initialValues={{
                  address: '',
                }}
                validationSchema={VALIDATION_STEP_4}
                onSubmit={onSubmit}
              >
                <Form>
                  <Step4Content>
                    <BaseGoogleAutocomplete
                      searchOptions={searchOptions}
                      name='address'
                      setLoaderGoogle={setLoaderGoogle}
                      addressObj={addressObj}
                      setAddressObj={setAddressObj}
                      errGoogle={errGoogle}
                      setErrGoogle={setErrGoogle}
                    />
                  </Step4Content>
                  <AnimatePresence>
                    {!loaderGoogle ? (
                      <motion.div
                        variants={fadeTop}
                        initial='hidden'
                        animate='visible'
                        exit='hidden'
                      >
                        <Footer prevArrowClick={() => dispatch(prevStep())}>
                          <FooterOkBtn type='submit'>
                            OK <HiOutlineCheck />
                          </FooterOkBtn>
                          <FooterPressText>press Enter ↵</FooterPressText>
                        </Footer>
                      </motion.div>
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          margin: '20px 0',
                        }}
                      >
                        <BaseSpinner />
                      </div>
                    )}
                  </AnimatePresence>
                </Form>
              </Formik>
            </StepLayout>
          ) : (
            <>{/* FeedBack Component with 3 states */}</>
          )}
        </>
      ) : (
        <>
          <BaseSpinner />
        </>
      )}
    </AnimateTop>
  );
};

export default memo(Step4);
